// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Unibrow-cls1___490b80e611ed57fa86a{/*!*/}.Unibrow-cls2___3e6cd22bf1631e0ed5b{display:flex;align-items:center;grid-gap:8px;gap:8px;grid-gap:var(--spacing-xs-8, 8px);gap:var(--spacing-xs-8, 8px)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Unibrow-cls1___490b80e611ed57fa86a",
	"cls2": "Unibrow-cls2___3e6cd22bf1631e0ed5b Unibrow-cls1___490b80e611ed57fa86a"
};
export default ___CSS_LOADER_EXPORT___;
